import { render, staticRenderFns } from "./PortfolioHero.vue?vue&type=template&id=4c06fb59&scoped=true"
import script from "./PortfolioHero.vue?vue&type=script&lang=ts&setup=true"
export * from "./PortfolioHero.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PortfolioHero.vue?vue&type=style&index=0&id=4c06fb59&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c06fb59",
  null
  
)

export default component.exports